import { render, staticRenderFns } from "./SampleDialog.vue?vue&type=template&id=6304ac70&scoped=true&"
import script from "./SampleDialog.vue?vue&type=script&lang=js&"
export * from "./SampleDialog.vue?vue&type=script&lang=js&"
import style0 from "./SampleDialog.vue?vue&type=style&index=0&id=6304ac70&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./SampleDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6304ac70",
  null
  
)

export default component.exports